import { BaseReq, PaginationReq, PaginationResp } from "@/core/interface";

class UnitBaseReq extends BaseReq {
  name: string = ""; // 结算单位名称
  symbol: string = ""; // 单位符号
}

export class UnitReq extends UnitBaseReq {
  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class UnitPageReq extends PaginationReq {
  name: string = "";

  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class UnitPageRecord {
  bizNo: string = ""; // 单位编号
  name: string = ""; // 单位名称
  symbol: string = ""; // 单位符号
  modifiedName: string = ""; // 最近更新人
  lastModifiedTime: string = ""; // 最近更新时间
}

export class UnitPageResp extends PaginationResp<UnitPageRecord> {}

class UnitSimpleListRecord {
  id: number = 0;
  name: string = "";
}

export class UnitSimpleListResp {
  records: UnitSimpleListRecord[];
}

export class UnitDetailResp {
  bizNo: string = ""; // 单位编号
  name: string = ""; // 单位名称
  symbol: string = ""; // 单位符号
}
